import { atomWithReset } from 'jotai/utils';

import { type CityFilters, INITIAL_CITY_FILTERS } from '../../types/cityFilters';

/**
 * Átomo com o estado dos filtros (client-side) da listagem de Cidades.
 *
 * Deve ser consumido apenas via `useCityFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const cityFiltersAtom = atomWithReset<CityFilters>(INITIAL_CITY_FILTERS);
